<template>

    <section class="content">
      <div class="d-flex justify-content-end justify-content-between">
        <div class="w-100" v-if="!page?.items?.length">
          <EmptyListMessage />
        </div>
        <div class="d-flex w-100 justify-content-end mb-4 actions">
          <button-component class="width-auto mr-2" v-if="!isReadonly" :disabled="importInProgress" @click="importData()">Импорт</button-component>
          <button-component class="width-auto" v-if="!isReadonly" :disabled="importInProgress" @click="addCard()">Создать</button-component>
          <!--      <button-component  class="width-auto" kind="tertiary" @click="modals.filter = !modals.filter">-->
          <!--        <template #prepend>-->
          <!--          <icon-component class="mr-2" name="filter" />-->
          <!--        </template>-->
          <!--        Фильтр-->
          <!--      </button-component>-->
        </div>

      </div>
      <template v-if="importInProgress">
        <Loader />
      </template>
      <template v-else-if="page?.items?.length">
        <table class="table-custom ">
          <thead>
            <tr>
              <th width="5%"></th>
              <th width="10%">№ карты</th>
              <th width="10%">№ ИППСУ</th>
              <th>Дата составления</th>
              <th>Срок действия</th>
              <th>Форма социального обслуживания</th>
              <th>Файл</th>
              <th>Статус</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in page.items" :key="item.id" v-on:dblclick="editCard(item.id)">
              <td><menu-component class="actions" :actions="actions(item)" /></td>
              <td>{{ item.num }}</td>
              <td>{{ item.ippsuNumber }}</td>
              <td>{{ $momentFormat(item.date, "DD.MM.YYYY") }}</td>
              <td>{{ item.journalIppsuServices.length ? $momentFormat(item.journalIppsuServices[0].endDate, "DD.MM.YYYY") : "" }}</td>
              <td>{{ item.journalIppsuServices.map(x => x.socialTypeInfo ).filter((v, i, a) => a.indexOf(v) === i).join(', ') }}</td>
              <td>
                <file-download :file="item.file"/>
              </td>
              <td>
                {{ item.statusString == "" ? "Без статуса" : item.statusString }}
              </td>
            </tr>
          </tbody>
        </table> 
        
        <div v-if="page.pagesTotal > 1" class="mt-4">
          <Pagination :page-count="page.pagesTotal" :current-page="page.pageNumber" @change="onPageChange($event)"/>
        </div>
        <div>
          <PageCounter :isFiltered="false" :totalCount="totalCount" :filteredCount="page.itemsTotal" />
        </div>
      </template>

      <div class="card-footer mt-5">
            <div class="d-flex align-items-center float-right">
              <button-component kind="secondary" type="button" class="btn btn-default" v-on:click="close">Закрыть</button-component>
            </div>
      </div>
      <section class="modals">
        <transition name="filter">
          <div class="filter" v-if="modals.filter">
            <IppsuFilters
              v-bind:filters="filters"
              v-on:apply="onFiltersApply($event)"
              v-on:reset="onFiltersReset($event)"
            />
          </div>
        </transition>
      </section>
    </section>

</template>

<script>
import IppsuApi from "../api/ippsu";
import IppsuFilters from "../components/IppsuFilters.vue";
import ButtonComponent from "@/common/ui/ButtonComponent";
import FileDownload from "@/common/components/FileDownload";
import MenuComponent from "@/common/ui/components/page/MenuComponent";
import Constants from "@/common/constants";
import PageCounter from "@/common/components/PageCounter";
import Loader from "@/common/ui/Loader";
// import Constants from "../../../common/constants";

export default {
  name: "Journals",
  components: {
    MenuComponent,
    ButtonComponent,
    IppsuFilters,
    FileDownload,
    PageCounter,
    Loader
  },
  created() {
    const self = this;
    IppsuApi.search(Object.assign({ pageNumber: 1, pageSize: 1 }, { journalId: self.journalId })).then(function (response) {      
      console.log(response.data);
      self.totalCount = response.data.itemsTotal;
    });
    this.loadIppsu();
  },
  props: {
    journalId: Number,
    patientId: Number,
    isReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    request: {
      pageNumber: 1,
      pageSize: Constants.pageSize
    },
    page: {},
    modals: {
      filter: false,
    },
    totalCount: 0,
    importInProgress: false
  }),
  methods: {
    actions(item) {
      let result = [{
        title: 'Просмотр',
        icon: 'eye',
        click: () => this.viewCard(item.id)
      }];
      if (!this.isReadonly) {
        result.push({
          title: 'Редактировать',
          icon: 'pen',
          click: () => this.editCard(item.id)
        });
      }
      return result;
    },
    loadIppsu() {
      const vm = this;
      let params = Object.assign({}, { journalId: this.journalId }, this.request);
      console.log(params);
      IppsuApi.search(params).then(function (response) {
        vm.page = response.data;
      });
    },
    onPageChange(pageNumber) {
      this.request.pageNumber = pageNumber;
      this.loadIppsu()
    },
    onFiltersApply(filters) {
      this.filters = filters;
      this.modals.filter = false;
      this.loadIppsu();
    },
    onFiltersReset(filters) {
      this.filters = filters || {};
      this.modals.filter = false;
      this.loadIppsu();
    },
    viewCard(id) {
      this.patient = id;
      this.modals.view = true;
      this.$router.push({ name: "ippsuCard", params: { patient_id: this.patientId, action: 'view', id: id } });
    },
    editCard(id) {
      if (!this.isReadonly) {
        this.$router.push({name: "ippsuCard", params: {patient_id: this.patientId, action: 'edit', id: id}});
      } else {
        this.viewCard(id);
      }
    },
    addCard() {
      this.$router.push({ name: "ippsuCard", params: { patient_id: this.patientId, action: 'add' } });
    },
    close() {
      this.$router.push({name: 'Journal', query: { page1: this.$route.query.page1 }});
    },   
    importData() {
      if (this.journalId)
        this.importInProgress = true;
        IppsuApi.importData(this.journalId).then(response => {
          let data = response.data;
          if (!data.succeed) {
            Constants.alert.fire('Ошибка', data.message, 'error');
            this.importInProgress = false;
          }
          else {
            let message = 'Данные успешно импортированы. ' +
                          'Новые - ' + data.new + '. Измененные - ' + data.updated + 
                          '. Не требуют обновления - ' + data.upToDate + 
                          '. Не удалось импортировать - ' + data.failed + '.';
            Constants.alert.fire('Импорт', message, 'success');
            this.importInProgress = false;
            this.loadIppsu();
          }
        }).catch(() => {
          Constants.alert.fire('Ошибка', 'Не удалось импортировать данные.', 'error');
          this.importInProgress = false;
        });
    }     
  }
};
</script>

<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";

.content {
  padding: 0;
  position: relative;
  overflow-y: visible;
  .filter {
    position: absolute;
    width: 350px;
    height: auto;
    top: 0;
    right: 0;
    overflow: hidden;
    background-color: transparent;
    opacity: 1;
    transition: opacity 0.2s;
  }
  .filter-enter, .filter-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}

.card-footer{
    padding: 0;
    background-color: transparent;
    border: none;
}
</style>